import { render, staticRenderFns } from "./guide_detail.vue?vue&type=template&id=1140cba0&scoped=true"
import script from "./guide_detail.vue?vue&type=script&lang=js"
export * from "./guide_detail.vue?vue&type=script&lang=js"
import style0 from "./guide_detail.vue?vue&type=style&index=0&id=1140cba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140cba0",
  null
  
)

export default component.exports